import React from "react";

import HeaderAdmin from '../../blocks/headerAdmin';
import UserModal from "../../user/UserModal";

import {navMap} from './navMap';

function HeaderUsers() {
  return (
    <React.Fragment>
      <UserModal />
      <HeaderAdmin navMap={navMap} />
    </React.Fragment>
  );
}

export default HeaderUsers;
